import {
    $,
    $$,
    get,
    getDataText,
    clickOnEnterKey,
    gtmSimpleEvent,
    updateLanguageUrls,
    Key,
    isVisible,
    hide,
    show
} from "@/Utils";
import {EditCartFrom, GtmEventType} from "@/enums";

function selectTab(targetTab: HTMLElement) {
    targetTab.closest(".tabs-menu__list, [role='tablist']").querySelectorAll(".tabs-menu__item--active, [aria-selected='true']").forEach(x => {
        x.classList.remove("tabs-menu__item--active");
        x.setAttribute("aria-selected", "false");

        if (x.hasAttribute("data-menu-id")) {
            hide(get(x.getAttribute("data-menu-id")))
        }
        
        x.setAttribute("tabindex", "-1");
        const contentIdToHide = x.getAttribute("data-tab-id");
        let sectionToHide = get(contentIdToHide);
        sectionToHide?.classList.remove("tab-content--active");
    });
    targetTab.classList.add("tabs-menu__item--active");
    if (targetTab.hasAttribute("data-menu-id")) {
        show(get(targetTab.getAttribute("data-menu-id")))
    }
    targetTab.setAttribute("aria-selected", "true");
    targetTab.setAttribute("tabindex", "0");
    const target = targetTab.getAttribute("data-tab-id");
    if (target) {
        gtmSimpleEvent(GtmEventType.Tab, target);
        let targetSection = get(target);
        if (!targetSection) {
            console.warn(`Section for tab: "${target}" not found`)
        }
        let targetClassList = targetSection?.classList;
        targetClassList?.add("tab-content--active");
    }
    updateLanguageUrls(targetTab);
}

function onTabClick(e: Event) {
    const targetTab = e.currentTarget as HTMLElement
    e.preventDefault()
    if (targetTab.dataset.lazy === ""){
        const product = $(`[data-product-list-id="${EditCartFrom.ProductDetail}"]`)
        const id = product.getAttribute("data-product-id")
        let tabContentUrl : string;
        if (targetTab.dataset.tabId === "_CompatiblesTab"){
            tabContentUrl = window.config.compatibleProductsTabUrl;
        }
        else if (targetTab.dataset.responsivePanelTarget === "similar-products"){
            tabContentUrl = window.config.similarProductsTabUrl;
        }
        if (tabContentUrl){
            getDataText(tabContentUrl + "/" + id, (resp)=> {
                let tabContent = document.querySelector(`#${targetTab.dataset.responsivePanelTarget} .responsive-panel`);
                tabContent.innerHTML = resp;
                targetTab.dataset.lazy = "loaded"
            });
        }
    }
    const alreadyOpen = targetTab.classList.contains("tabs-menu__item--active")
    if (alreadyOpen) {
        return
    }
    const activateOtherTab = targetTab.getAttribute("data-activate-tab")
    let tabId: string
    if (activateOtherTab) {
        const tabToActivate = targetTab.getAttribute("data-tab-id")
        tabId =`${tabToActivate}Link`
            selectTab(get(tabId))
    } else {
        tabId = targetTab.id
        selectTab(targetTab)
    }
    const url = targetTab.getAttribute("data-url")
    if (url) {
        history.pushState({tabId: tabId}, null, url)
    }
}

function onTabKey(e: KeyboardEvent) {
    const current = e.currentTarget as HTMLElement;
    if (e.key === Key.Enter) {
        clickOnEnterKey(e, current)
        return
    }

    if (e.key === Key.ArrowLeft || e.key === Key.ArrowRight) {
        const tablist = current.closest("[role='tablist']")
        if (!tablist) {
            return
        }
        const tabsArr = Array.from(tablist.querySelectorAll("[role='tab']"))
        const tabs = tabsArr.filter((x: HTMLElement) => isVisible(x)) as HTMLElement[]
        const currentIndex = tabs.indexOf(current);
        let newIndex: number;
        if (e.key === Key.ArrowLeft) {
            newIndex = currentIndex > 0 ? currentIndex - 1 : tabs.length - 1;
        } else {
            newIndex = currentIndex < tabs.length - 1 ? currentIndex + 1 : 0;
        }

        const targetTab = tabs[newIndex] as HTMLElement;
        const focusableElement: HTMLElement = targetTab.matches('a, button, input, select, textarea, [tabindex]')
            ? targetTab
            : targetTab.querySelector('a, button, input, select, textarea, [tabindex]');
        focusableElement?.focus();
        if (!targetTab.getAttribute("data-tab-url")) {
            clickOnEnterKey(e, targetTab, true)
        }
    }
}

export function initTabs() {
    $$(".tabs-menu__list, [role='tablist']").forEach(list => {
        if(list.classList.contains("radio-tabs")) return; // Exception, radio inputs in payment step behave differently
        let activeTab = list.querySelector(".tabs-menu__item--active, [aria-selected='true']");
        if (!activeTab) {
            // No active tabs, make first one active, if it exists
            activeTab = list.querySelector(".tabs-menu__item, [role='tab']")
            activeTab?.classList.add("tabs-menu__item--active")
            activeTab?.setAttribute("aria-selected", "true")
            activeTab?.setAttribute("tabindex", "0")
        }
        const tab = activeTab?.getAttribute("data-tab-id");
        if (tab) {
            const tabContent = get(tab);
            if (tabContent) {
                tabContent.classList.add("tab-content--active");
            }
        }
        if (activeTab && activeTab.getAttribute("data-url")) {
            history.replaceState({tabId: activeTab.id}, null, window.location.href);
        }

        list.querySelectorAll(".tabs-menu__item, [role='tab']").forEach(elem => {
            elem.addDataBoundEventListener("click", onTabClick, "tabs");
            elem.addDataBoundEventListener("keydown", onTabKey, "tabs-key");
        });
    });
}

window.addEventListener("popstate",
  e => {
    if (e.state && e.state.tabId) {
      selectTab(get(e.state.tabId));
    }
  });

window.addEventListener("resize", () => {
  if (!window.isResponsive && get("newsListContainer")) {
    $$(".tabs-menu").forEach(x => {
      if (!x.querySelector(".tabs-menu__item--active"))
        (x.querySelector(".tabs-menu__item") as HTMLElement).click()
    })
  }
})
